class DrawerMenuGenderSwitch extends HTMLElement {
  constructor() {
    super();

    this.womenButton = this.querySelector('#womens-mobile-menu-nav-trigger');
    this.menButton = this.querySelector('#mens-mobile-menu-nav-trigger');

    this.womenButton.addEventListener('click', this.onWomenClick.bind(this));
    this.menButton.addEventListener('click', this.onMenClick.bind(this));

    this.womenSection = document.querySelector('#womens-drawer-menu');
    this.menSection = document.querySelector('#mens-drawer-menu');
  }

  onWomenClick(event) {
    event.preventDefault();

    this.menSection.classList.add('hidden');
    this.womenSection.classList.remove('hidden');
    this.womenButton.classList.add('menu-drawer__gender-switch-button--active');
    this.menButton.classList.remove('menu-drawer__gender-switch-button--active');
  }

  onMenClick(event) {
    event.preventDefault();

    this.womenSection.classList.add('hidden');
    this.menSection.classList.remove('hidden');
    this.womenButton.classList.remove('menu-drawer__gender-switch-button--active');
    this.menButton.classList.add('menu-drawer__gender-switch-button--active');
  }
}

customElements.define('drawer-menu-gender-switch', DrawerMenuGenderSwitch);
